angular.module('callX').controller('SupportPageCtrl', ['$scope','$stateParams','$modal','UserService','$rootScope', '$state', 'toaster', function($scope,$stateParams,$modal,UserService, $rootScope,$state, toaster) {
    
    var username_agent = $stateParams.username;
    $rootScope.userId = parseInt($stateParams.userId);
    // console.log($stateParams,$rootScope.userId, "get details from support")
    $scope.role ;
    $scope.getuserRole ;
    $scope.getsalesRole ;

    $scope.statusOptions = [
        'To Do',
        'In Progress',
        'Done',
    ];

    // $scope.searchPage = false;
    $scope.tableContentLoading=false; 
    // $scope.tableContentLoadingSearch=false;

    $scope.setAgentFirsAandLastName = function() {
        $scope.username_firstName = window.localStorage.getItem("first_name")
        $scope.username_lastName = window.localStorage.getItem("last_name")
        $scope.user_name = window.localStorage.getItem("user_name")
        $scope.user_id = window.localStorage.getItem("user_id")
        $scope.role = window.localStorage.getItem("role")
        if ($scope.role === 'AGENT') {
            $scope.role = 'salesagent';
        }
        $scope.email = window.localStorage.getItem("email")
        if($scope.role == 'useragent'){
            $scope.getuserRole = $scope.role;
            $scope.getAgentStats();
        }else if($scope.role == 'salesagent'){
            $scope.getsalesRole = $scope.role;
            $scope.getsalesAgentStats();
        }
    }

    $scope.limitTextLength = function(text) {
        return text.slice(0,150) + '..'
    }

    $scope.setAgentFirsAandLastName();

    $scope.currentPage = 1; 
    $scope.itemsPerPage = 10;
    $scope.maxSize = 3;
    $scope.supportData = []

    $scope.removeFileExtension = function(filename) {
        // Check if filename contains a dot indicating an extension
        if (filename && filename.lastIndexOf('.') !== -1) {
            // Split the filename by dot and return the first part (name only)
            return filename.substring(0, filename.lastIndexOf('.'));
        }
        // Return the filename as is if no extension is found
        return filename;
    } 

    $scope.extractDateFromTimestamp = function(timestamp) {
        if (!timestamp) {
            return ''; 
        }
        var datePart = timestamp.split(' ')[0];
        var parts = datePart.split('-');
        if (parts.length !== 3) {
            throw new Error('Invalid date format');
        }
        var year = parts[0];
        var month = parts[1];
        var day = parts[2];
        var shortYear = year.slice(2);
    
        // Format as DD/MM/YY
        return month + '/' + day + '/' + shortYear;
    };

    $scope.getSupportDetails = function(){
        $scope.tableContentLoading = true;
        $rootScope.currentPage = 'support';
        $state.go('app.sales-agent.support', { username: $scope.user_name, userId: $scope.user_id });
        var callbacks = {
        success: function(data) {
                $scope.supportData = data.content; 
                $scope.totalPages = data.total_pages;
                $scope.totalItems = data.total_elements;
                $scope.tableContentLoading = false;
            },
        failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        UserService.getSupportDetails($rootScope.userId, $scope.currentPage - 1, $scope.itemsPerPage, callbacks); 
    } 
    $scope.getSupportDetails();  
    

    $scope.pageChanged = function() {
        $scope.tableContentLoading = true;

        var callbacks = {
        success: function(data) {
            $scope.supportData = data.content; 
            $scope.totalPages = data.total_pages;
            $scope.totalItems = data.total_elements;

            $scope.tableContentLoading = false;
            },
        failure: function(data) {
            $scope.tableContentLoading = false;
            }
        }; 
        UserService.getSupportDetails($rootScope.userId, $scope.currentPage-1,$scope.itemsPerPage,callbacks);  
    } 

    // $scope.updateStatus = function(support) {
    //     console.log(support, "get support record ")
    //     if (support && support.id) {
    //         UserService.updateSupportStatus(support.id, support.status)
    //             .then(function(response) {
    //                 toaster.pop('success', 'Success', 'Status updated successfully', 2000);
    //             })
    //             .catch(function(error) {
    //                 toaster.pop('error', 'Error', 'An error occurred while updating status', 2000);
    //             });
    //     }
    // }; 

    $scope.editSupportStatus = function(support) {
        console.log(support, "get status update support")
        $scope.supportStatus = support.status;
        $scope.EditSupportStatusModal(support);
    }

    $scope.EditSupportStatusModal = function(support){
        // console.log("once modal is opened - rowData ->", rowData) 
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/support_status.html',
            controller: 'SupportStatusCtrl',
            size:'md',
            resolve :{
                statusData: function() {
                        return support.status;
                }
            }
        })

        modalInstance.result.then(function (editedStatus) {
            console.log("editedStatus ->", editedStatus)

            if (editedStatus) {
                itemToUpdate = $scope.supportData.find(function (item) {
                    return item.id === support.id;
                });
            }

            if (itemToUpdate) {
                var currentStatus = itemToUpdate.status;
                if(currentStatus !== editedStatus){
                            itemToUpdate.status = editedStatus;
                            var callbacks = {
                                success: function(data) {
                                    if(data !== null){
                                        toaster.pop('success', 'Success', 'Ticket Status Updated', 2000);
                                    }else {
                                        toaster.pop('error', 'Error', 'Failed to Update Status', 2000);
                                        itemToUpdate.status = currentStatus;
                                    }
                                },
                                failure: function(data) {
                                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                                    itemToUpdate.status = currentStatus;
                                    // init();
                                }
                            };
                            UserService.updateSupportStatus(itemToUpdate.id, itemToUpdate.status, callbacks);
                }else {
                    console.log("Status is already updated, no need to make the API call");
                }
            }

            }, function () {
        });
    } 

    $scope.supportEditForm = function(edit_support){
        $scope.openSupportEditFormModal(edit_support);
    } 

    $scope.openSupportEditFormModal = function(edit_support) {
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/support_page_edit.html',
            controller: 'SupportPageEditCtrl',
            size: 'md',
            windowClass: 'custom-rounded-modal',
            backdrop: 'static',
            resolve: {
                object: function () {
                    return {
                        support:edit_support
                    }
                }
            }
        });
            modalInstance.result.then(function (selectedItem) {
                    // $scope.selected = selectedItem;
                    if (selectedItem == 'ok') {
                        $scope.getSupportDetails();
                    }
            }, function () {
            
            });
    } 

  }]);